// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import Vue from 'vue'
import App from './App'
import { forceAddWatermark, watermarkDirective } from './common/watermark'
import router from './router'
import store from './store'
import './store/permission'
// fade/zoom 等
// import 'element-ui/lib/theme-chalk/base.css'
// css样式
import 'element-ui/lib/theme-chalk/index.css'
// import 'font-awesome/css/font-awesome.min.css'
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Moment from 'vue-moment'

library.add(fas, fab)
dom.watch()
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.directive('watermark', watermarkDirective)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(ElementUI)
Vue.use(Moment)

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    if (store.getters.token) {
      forceAddWatermark()
    }
  }
}).$mount('#app')
